import React, { useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from '../../contexts/CartContext';
import Cart from './Cart';

const CartButton = () => {
  const { cart } = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  
  const handleCartOpen = () => {
    setCartOpen(true);
  };
  
  const handleCartClose = () => {
    setCartOpen(false);
  };
  
  return (
    <>
      <Tooltip title="View Cart">
        <IconButton 
          color="inherit" 
          onClick={handleCartOpen}
          aria-label="Shopping Cart"
        >
          <Badge 
            badgeContent={cart.itemCount} 
            color="secondary"
            overlap="circular"
            sx={{
              '& .MuiBadge-badge': {
                right: -3,
                top: 3,
              },
            }}
          >
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      
      <Cart open={cartOpen} onClose={handleCartClose} />
    </>
  );
};

export default CartButton;
